import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ShiftsPage } from '@/features/pos/shifts/shifts-list-page'

export const Route = createFileRoute('/_dashboard/shifts/$shiftId')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ShiftSelected,
})

function ShiftSelected() {
  const { shiftId } = Route.useParams()
  return <ShiftsPage selectedId={shiftId} />
}
